import { render, staticRenderFns } from "./FormThuxHorizontalAutocomplete.vue?vue&type=template&id=54788de3&"
import script from "./FormThuxHorizontalAutocomplete.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports